import { preparedValidationSchemaForContacts } from '@arnold/common';
import { TFunction } from 'i18next';
import parsePhoneNumber from 'libphonenumber-js';
import * as Yup from 'yup';
import { ContactType } from '../../../generated/hooks';
import { SurveyGroupEntries } from './ProcessSurveySelect';
export const createValidationSchema = (
  t: TFunction,
  otherRespondentEmails: string[] = [],
  otherRespondentPhoneNumbers: string[] = [],
  onboardingSurveysToAdd: SurveyGroupEntries = {},
  processSurveysToAdd: SurveyGroupEntries = {},
) => {
  // Get the basic contact validation schema
  const contactSchema = preparedValidationSchemaForContacts(t);

  // Create the extended schema with duplicate validation
  return Yup.object().shape({
    firstname: Yup.string().required(t('enterName')),
    surname: Yup.string().required(t('enterSurname')),
    teamId: Yup.string().required(t('enterTeamleader')).nullable(),
    primaryEmail: contactSchema.primaryEmail.concat(
      Yup.string().test('is-unique', t('duplicateEmailError'), function (value) {
        return !value || !otherRespondentEmails.includes(value);
      }),
    ),
    secondaryEmail: contactSchema.secondaryEmail.concat(
      Yup.string().test('is-unique', t('duplicateEmailError'), function (value) {
        return !value || !otherRespondentEmails.includes(value);
      }),
    ),
    phone: contactSchema.phone.concat(
      Yup.string().test('is-unique', t('duplicatePhoneError'), function (value) {
        const { parent } = this;
        if (!value || !parent.callingCode) return true;
        const fullPhoneNumber = `+${parent.callingCode}${value}`;
        return !otherRespondentPhoneNumbers.includes(fullPhoneNumber);
      }),
    ),
    callingCode: contactSchema.callingCode,
    preferredContactType: contactSchema.preferredContactType,
    addToOnboarding: Yup.boolean().test('dateRequired', t('dateRequired'), function (value) {
      if (!value) return true;
      return !Object.values(onboardingSurveysToAdd).some((sg) => sg.checked && !sg.addedOn);
    }),
    addToProcessSurveys: Yup.boolean().test('dateRequired', t('dateRequired'), function (value) {
      return !Object.values(processSurveysToAdd).some((sg) => sg.checked && !sg.addedOn);
    }),
  });
};

export const handlePhoneChange = (handler: any) => (e: any) => {
  const { target } = e;
  const { value } = target;

  handler({ target });

  if (value) {
    const valueWithoutSpaces = value.replace(/\s+/g, '');
    const parsedPhoneNumber = parsePhoneNumber(valueWithoutSpaces);
    if (parsedPhoneNumber) {
      handler({
        target: { name: 'callingCode', value: parsedPhoneNumber.countryCallingCode },
      });
      handler({
        target: { name: target.name, value: parsedPhoneNumber.nationalNumber },
      });
    } else {
      handler({
        target: { name: target.name, value: valueWithoutSpaces },
      });
    }
  }

  if (!value) {
    handler({
      target: { name: 'preferredContactType', value: ContactType.Email },
    });
  }
};

export const handleEmailChange = (handler: any) => (e: any) => {
  const { target } = e;
  const { value } = target;
  handler({ target });
  if (!value) {
    handler({
      target: { name: 'preferredContactType', value: ContactType.Sms },
    });
  }
};

export const handlePhoneBlur = async (cc: string, phoneNumber: string, verifyNumber: (phoneNumber: string) => void) => {
  const internationalPhoneNumber = `+${cc}${phoneNumber}`;
  if (
    /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/.test(
      internationalPhoneNumber,
    )
  ) {
    verifyNumber(internationalPhoneNumber);
  }
};
